import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=1523b435"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1523b435')) {
      api.createRecord('1523b435', component.options)
    } else {
      api.reload('1523b435', component.options)
    }
    module.hot.accept("./Listado.vue?vue&type=template&id=1523b435", function () {
      api.rerender('1523b435', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/aspectos/Listado.vue"
export default component.exports